package org.matthewo.schema.games

import org.matthewo.math.minus
import org.matthewo.math.plus
import org.matthewo.schema.CRI_YEAR_PREFIX
import org.matthewo.schema.RankingMetrics
import org.matthewo.schema.StandardMetrics
import org.matthewo.symbolprocessor.GameSchema
import org.matthewo.symbolprocessor.Metric
import org.matthewo.symbolprocessor.Period

@GameSchema(CRI_YEAR_PREFIX + 2022, "Power Play CRI", 3)
interface MetricsPowerPlayCRI<T : Number> : StandardMetrics<T>, RankingMetrics<T> {
    override val tbp1 get() = auto

    @Metric(Period.AUTO, "Terminal")
    val apTerminal: T

    @Metric(Period.AUTO, "Ground Junction")
    val apGround: T

    @Metric(Period.AUTO, "Low Junction")
    val apLow: T

    @Metric(Period.AUTO, "Medium Junction")
    val apMedium: T

    @Metric(Period.AUTO, "High Junction")
    val apHigh: T

    @Metric(Period.AUTO, "Transformed")
    val apTransformed: T

    @Metric(Period.AUTO, "Park")
    val apPark: T

    @Metric(Period.AUTO, "Navigation")
    val apNavigation: T

    @Metric(Period.TELEOP, "Terminal Near")
    val tpTerminalNear: T

    @Metric(Period.TELEOP, "Terminal Far")
    val tpTerminalFar: T

    @Metric(Period.TELEOP, "Ground Junction")
    val tpGround: T

    @Metric(Period.TELEOP, "Low Junction")
    val tpLow: T

    @Metric(Period.TELEOP, "Medium Junction")
    val tpMedium: T

    @Metric(Period.TELEOP, "High Junction")
    val tpHigh: T

    @Metric(Period.TELEOP, "Transformed")
    val tpTransformed: T

    @Metric(Period.ENDGAME, "Ownership")
    val epOwnership: T

    @Metric(Period.ENDGAME, "Circuit")
    val epCircuit: T

    @Metric(Period.ENDGAME, "Park")
    val epPark: T
}

fun <T : Number> MutableMetricsPowerPlayCRI<T>.computeTotals() {
    auto = apTerminal + apGround + apLow + apMedium + apHigh + apTransformed + apNavigation + apPark
    teleop = tpTerminalNear + tpTerminalFar + tpGround + tpLow + tpMedium + tpHigh + tpTransformed
    endgame = epOwnership + epCircuit + epPark
    npTotal = auto + teleop + endgame
    total = npTotal - penalty
}
